import { Link } from "react-router-dom";
import { Linkedin, Instagram, Youtube, Mail, MapPin, Phone } from "lucide-react";

// Update these handles with your real profile URLs once you're happy with them.
const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/zerolabs-digitals",
  instagram: "https://www.instagram.com/zerolabsdigitals",
  youtube: "https://www.youtube.com/@zerolabsdigitals",
  whatsapp: "https://wa.me/918971452224",
};

function WhatsAppIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.296-.767.966-.94 1.164-.174.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.2-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.012 21.786h-.008a9.766 9.766 0 0 1-4.98-1.363l-.357-.213-3.71.973 1-3.62-.234-.373a9.802 9.802 0 0 1-1.5-5.226C2.223 6.5 6.596 2.126 12.017 2.126c2.635 0 5.11 1.026 6.973 2.889a9.777 9.777 0 0 1 2.892 6.984c-.003 5.417-4.417 9.787-9.87 9.787zm8.413-18.2A11.767 11.767 0 0 0 12.017 0C5.518 0 .224 5.288.22 11.786c0 2.063.545 4.098 1.579 5.893L.061 24l6.485-1.7a11.755 11.755 0 0 0 5.464 1.394h.006c6.499 0 11.793-5.29 11.796-11.789.001-3.152-1.223-6.113-3.446-8.343z"/>
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-4">
            <img
              src="/brand/zerolabs-mark.png"
              alt=""
              aria-hidden="true"
              className="h-10 w-auto select-none drop-shadow-[0_0_12px_rgba(59,130,246,0.45)]"
              draggable="false"
            />
            <img
              src="/brand/zerolabs-wordmark.png"
              alt="ZeroLabs Digitals"
              className="h-9 w-auto select-none drop-shadow-[0_0_10px_rgba(59,130,246,0.4)]"
              draggable="false"
            />
          </div>
          <p className="text-[#B6B0C7] max-w-md leading-relaxed">
            Innovating Today. Engineering Tomorrow. <br/>
            <span className="text-white">Empowering Businesses with Intelligent Technology.</span>
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href="mailto:info@zerolabsdigi.in" data-testid="footer-email" className="text-[#B6B0C7] hover:text-[#22D3EE] inline-flex items-center gap-2">
              <Mail size={14}/> info@zerolabsdigi.in
            </a>
            <a href="tel:+918971452224" data-testid="footer-phone" className="text-[#B6B0C7] hover:text-[#22D3EE] flex items-center gap-2">
              <Phone size={14}/> +91 8971452224
            </a>
            <div className="text-[#B6B0C7] flex items-start gap-2" data-testid="footer-address">
              <MapPin size={14} className="mt-0.5 shrink-0 text-[#22D3EE]"/>
              <span>
                4172, 3rd Floor, 17th Main, 5th Cross,<br/>
                MCC B Block, Davangere — 577004,<br/>
                Karnataka, India.
              </span>
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-3">Services</div>
          <ul className="space-y-2 text-[#B6B0C7] text-sm">
            <li><Link className="hover:text-white" to="/software">Web Application Development</Link></li>
            <li><Link className="hover:text-white" to="/software">Mobile Application Development</Link></li>
            <li><a className="hover:text-white" href="/#ai">AI Automation</a></li>
            <li><Link className="hover:text-white" to="/plant-engineering">Plant Engineering</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-3">Company</div>
          <ul className="space-y-2 text-[#B6B0C7] text-sm">
            <li><a className="hover:text-white" href="/#why">Why Us</a></li>
            <li><Link className="hover:text-white" to="/products">Products</Link></li>
            <li><Link className="hover:text-white" to="/blogs">Blogs</Link></li>
            <li><a className="hover:text-white" href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-3">Account</div>
          <ul className="space-y-2 text-[#B6B0C7] text-sm">
            <li><Link className="hover:text-white" to="/login">Sign in</Link></li>
            <li><Link className="hover:text-white" to="/register">Create account</Link></li>
            <li><a className="hover:text-white" href="/contact#book">Book a consultation</a></li>
          </ul>

          <div className="mt-6" data-testid="footer-social">
            <div className="eyebrow mb-3">Follow us</div>
            <div className="flex items-center gap-3 md:justify-start">
              <a href={SOCIAL.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"
                 data-testid="footer-social-linkedin"
                 className="w-9 h-9 rounded-lg border border-white/10 bg-white/[0.03] text-[#B6B0C7] hover:text-white hover:border-[#3B82F6]/50 hover:bg-[#3B82F6]/10 transition-colors flex items-center justify-center">
                <Linkedin size={16}/>
              </a>
              <a href={SOCIAL.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
                 data-testid="footer-social-instagram"
                 className="w-9 h-9 rounded-lg border border-white/10 bg-white/[0.03] text-[#B6B0C7] hover:text-white hover:border-[#EC4899]/50 hover:bg-[#EC4899]/10 transition-colors flex items-center justify-center">
                <Instagram size={16}/>
              </a>
              <a href={SOCIAL.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"
                 data-testid="footer-social-youtube"
                 className="w-9 h-9 rounded-lg border border-white/10 bg-white/[0.03] text-[#B6B0C7] hover:text-white hover:border-red-500/50 hover:bg-red-500/10 transition-colors flex items-center justify-center">
                <Youtube size={16}/>
              </a>
              <a href={SOCIAL.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp"
                 data-testid="footer-social-whatsapp"
                 className="w-9 h-9 rounded-lg border border-white/10 bg-white/[0.03] text-[#B6B0C7] hover:text-white hover:border-[#25D366]/60 hover:bg-[#25D366]/10 transition-colors flex items-center justify-center">
                <WhatsAppIcon size={16}/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#6F687F]">© {new Date().getFullYear()} ZeroLabs Digitals. All rights reserved.</p>
          <div className="flex items-center gap-4 text-[#6F687F] text-xs">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-[#22D3EE]">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-[#22D3EE]">Terms</Link>
            <a href="/contact" className="hover:text-[#22D3EE]">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
